// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 40px;
  background: var(--button-color);
  position: relative;
}

.header-left {
  min-width: 200px;
}

.company-logo {
  height: 40px;
  max-width: 150px;
  object-fit: contain;
}

.header-nav {
  display: flex;
  gap: 0;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.nav-tab {
  padding: 12px 32px;
  background: transparent;
  color: #fff;
  border: none;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  border-radius: 24px;
  transition: all 0.3s;
}

.nav-tab.active {
  background: #fff;
  color: var(--button-color);
}

.nav-tab:hover:not(.active) {
  background: var(--hover-color);
}

.header-actions {
  display: flex;
  gap: 16px;
  align-items: center;
}

.btn-settings,
.btn-user {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  color: var(--button-color);
}

.btn-settings {
  font-size: 20px;
}

.btn-user:hover,
.btn-settings:hover {
  background: #e0e0e0;
}

/* Settings dropdown menu */
.settings-menu-container {
  position: relative;
}

.settings-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 220px;
  z-index: 100;
  overflow: hidden;
}

.settings-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  text-align: left;
  transition: background 0.2s;
}

.settings-item:hover {
  background: #f5f5f5;
}

.settings-item svg {
  color: #666;
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/Header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 40px;\n  background: var(--button-color);\n  position: relative;\n}\n\n.header-left {\n  min-width: 200px;\n}\n\n.company-logo {\n  height: 40px;\n  max-width: 150px;\n  object-fit: contain;\n}\n\n.header-nav {\n  display: flex;\n  gap: 0;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.nav-tab {\n  padding: 12px 32px;\n  background: transparent;\n  color: #fff;\n  border: none;\n  font-size: 16px;\n  font-weight: 400;\n  cursor: pointer;\n  border-radius: 24px;\n  transition: all 0.3s;\n}\n\n.nav-tab.active {\n  background: #fff;\n  color: var(--button-color);\n}\n\n.nav-tab:hover:not(.active) {\n  background: var(--hover-color);\n}\n\n.header-actions {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.btn-settings,\n.btn-user {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #fff;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--button-color);\n}\n\n.btn-settings {\n  font-size: 20px;\n}\n\n.btn-user:hover,\n.btn-settings:hover {\n  background: #e0e0e0;\n}\n\n/* Settings dropdown menu */\n.settings-menu-container {\n  position: relative;\n}\n\n.settings-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  min-width: 220px;\n  z-index: 100;\n  overflow: hidden;\n}\n\n.settings-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 16px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  color: #333;\n  text-align: left;\n  transition: background 0.2s;\n}\n\n.settings-item:hover {\n  background: #f5f5f5;\n}\n\n.settings-item svg {\n  color: #666;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
